<template>
  <page-container :title="titlePage">
    <template slot="description">
      <div>{{ description }}</div>
    </template>

    <template slot="before">
      <div class="questionnaire-process__right">
        <el-steps direction="vertical" :active="visitStage" finish-status="success" style="padding: 20px">
          <span @click="goItem">
            <el-step description="Выберите доступный визит" data-item="1">
              <div slot='title' class="navigation__item">Выбор визита</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>
            <el-step description="Просмотр анкет" data-item="2">
              <div slot='title' class="navigation__item">Анкета</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>

            <el-step description="Данные скринингов" data-item="3">
              <div slot='title' class="navigation__item">Динамика</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>
            <transition name="fade">
              <el-step v-show="!documentsAvailable" description="Просмотр документов" data-item="4" class="">
                        <div slot='title' class="navigation__item">Документы</div>
                        <div slot="icon" class="step__icon"></div>
              </el-step>
            </transition>
            <el-step description="Просмотр данных приборов" data-item="5">
              <div slot='title' class="navigation__item">Приборы</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>
          </span>
        </el-steps>
      </div>
    </template>
    <router-view/>

  </page-container>
</template>

<script>
import PageContainer from "@/components/elements/PageContainer";
import {mapActions, mapGetters, mapState} from "vuex"

export default {
  name: "visit",
  components: {PageContainer},
  data() {
    return {
      show: true,
      loadingVisit: false,
      stages: {
        1: 'visit.list',
        2: 'visit.item',
        3: 'visit.dynamics',
        4: 'visit.documents',
        5: 'visit.device',
      }
    }
  },
  computed: {
    ...mapState("visit", {
      stage: (state) => state.stage,
      visit: (state) => state.data,
    }),
    ...mapGetters("userDocuments", {
          documentsAvailable: "documentsAvailable"
        }
    ),
    titlePage() {
      return this.stage === 2 ? '' : this.$route.meta.title
    },
    visitStage() {
      if (!this.stage) return 0

      return this.stage | 0
    },
    titleContent() {
      return this.$staticData.visit.title[this.visitStage]
    },
    description() {
      let ret
      if (this.stage === 0) ret = '';
      if (this.stage === 1) ret = 'Выбор визита  •  Анкеты'
      if (this.stage === 2) ret = ''
      return ret
    }
  },
  created() {
  },
  methods: {
    ...mapActions({
      current: "session/CURRENT",
    }),
    goItem(el) {
      let index_page = 0

      if (!this.visit) {
        this.$notify.warning({
          title: "Нужно открыть визит",
          message: "Для перехода на другой шаг, пожалуйста откройте визит",
        });
        return
      }

      for (let i of el.path) {
        if (Array.from(i.classList).includes('el-step')) {
          index_page = (i.dataset.item)
          break
        }
      }


      if (this.$route.name !== this.stages[index_page]) this.$router.push({
        name: this.stages[index_page],
        params: {id: this.visit.id, visit: this.visit}
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}

.fade-enter, .fade-leave-to {
  height: 0;
  opacity: 0;
}

.user-block {
  height: 0;
  margin-top: 10px;
  transition: all .3s ease;
  overflow: hidden;
}

.show {
  height: 260px;
}

.visit {
  margin: 0 10px;

  border-radius: 8px;
  border: 1px solid #dfe0eb;
  box-shadow: none;

  &__item {
    color: #303133;
    transition: 0.3s;
    margin: 10px auto 0 auto;

    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    max-width: 100%;
    box-shadow: none;
    background: #fff;

    &:hover {
      box-shadow: 2px 2px 24px 2px rgba(69, 90, 100, 0.28);
    }
  }

  &_options {
    color: #000;
    font-weight: 400;
    font-size: 16px !important;
    line-height: 26px;

    display: flex;
    width: 100%;

    & .left-content {
      max-width: 350px;
      background: linear-gradient(to right, #3e7bd4, #2b5694);
      padding: 30px 25px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      text-align: center;
      color: #fff;

      & img {
        border-radius: 5px;
        margin-bottom: 10px;
      }

      & h4 {
        margin-bottom: 10px;
      }

      & p {
        font-size: 12px;
      }
    }

    & .right-content {
      width: 100%;
      background: #fff;
      padding: 0 10px 10px 10px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      .params-list {
        width: 100%;

        margin: 0 auto;
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: repeat(auto-fit, minmax(100px, 2fr));

        justify-content: space-between;
        align-items: center;
        text-align: center;
        align-self: center;
        align-content: center;

        &__item {
          display: grid;
          align-items: center;
          justify-items: center;
          align-self: stretch;

          background-color: #f3f2f2;
          color: white;
          border-radius: 10px;
          padding: 5px;

          h4 {
            color: #353c4e;
            margin: 5px 0 2px 0;
            font-size: 13px;
          }

          p {
            font-size: 13px;
            color: #919aa3;
            margin: 5px 0 0 0;
          }
        }
      }
    }

    & .social_media ul {
      display: flex;
    }

    & .social_media ul li {
      width: 45px;
      height: 45px;
      background: linear-gradient(to right, #01a9ac, #01dbdf);
      margin-right: 10px;
      border-radius: 5px;
      text-align: center;
      line-height: 45px;
    }

    & .social_media ul li a {
      color: #fff;
      display: block;
      font-size: 18px;
    }
  }

  &__description {
    color: #ccc;
    font-size: 16px !important;
    line-height: 26px;
    display: inline;
  }

  &__time {
    color: #40c700;
    font-size: 16px !important;
    line-height: 26px;
  }

  &__worker {
    color: #747474;
    font-size: 16px !important;
    line-height: 26px;
  }

  &__btn {
    text-align: center;
  }
}

.visit-data {
  margin: 15px 0 10px 0;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;

  &__name {
    margin: 0;
    color: #353c4e;
    text-transform: uppercase;
    letter-spacing: 5px;
  }

  &__department {
    font-size: 12px;
    padding-left: 10px;
    color: #ccc;
  }
}

.navigation {
  padding: 20px;

  &__item {
    cursor: pointer;

    &:hover {
      //color: #555;
    }
  }
}

</style>
<style lang="scss">
.questionnaire-process__right {
  width: 100%;

  .el-step__description {
    margin-bottom: 10px;
  }
}

.visit {
  .el-card__body {
    padding: 0 !important;
  }
}
</style>
